/**
 * Combined length of message text and HTML for comparison.
 * @param {?Object} msg Message with optional string fields `content` and `html`.
 * @return {number} Sum of string lengths.
 */
function messageContentFootprint(msg) {
  if (!msg) return 0;
  const c = msg.content != null ? String(msg.content) : '';
  const h = msg.html != null ? String(msg.html) : '';
  return c.length + h.length;
}

/**
 * When re-fetching `/insights/thread/.../history`, avoid replacing Redux with a snapshot that is
 * clearly behind the in-memory transcript (for example assistant still streaming or persistence lag).
 * @param {!Array<?>} localHistory In-memory chat messages.
 * @param {!Array<?>} remoteHistory Server chat messages.
 * @return {boolean} True to skip applying `loadThread` with `remoteHistory`.
 */
export function isRemoteThreadHistoryStale(localHistory, remoteHistory) {
  if (!Array.isArray(localHistory) || !Array.isArray(remoteHistory)) {
    return false;
  }
  if (localHistory.length > remoteHistory.length) {
    return true;
  }
  if (localHistory.length !== remoteHistory.length || localHistory.length === 0) {
    return false;
  }
  const locLast = localHistory[localHistory.length - 1];
  const remLast = remoteHistory[remoteHistory.length - 1];
  if (locLast?.role === 'assistant' && remLast?.role === 'assistant') {
    return messageContentFootprint(locLast) > messageContentFootprint(remLast);
  }
  return false;
}
